import {debugLog} from "../Utils/LogUtils";
import moment from "moment";
import {useEffect} from "react";
import {PLAN_TYPE_IDS, yearsToMaturity} from "../Utils/PlanUtils";

//We can set the deposit code based on the maturity date and the effective date.
export default function useUpdateDepositCodeBasedOnMatAndEffectiveDates(state) {
    const plan = state.plan;
    const setPlan = state.setPlan;

    useEffect(() => {
        if (!state.enrollment.state) { return; }
        const yearsToMat = yearsToMaturity(state);
        if (yearsToMat <= 0) { return; }
        if (plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
            let depositCode = 18 - yearsToMat + 1;
            if (depositCode < 1) {
                depositCode = 1; //This should never happen
            }
            if (depositCode > 13) {
                depositCode = 13;
            }
            setPlan(prevData => ({...prevData, depositCode: depositCode}));
        } else {
            setPlan(prevData => ({...prevData, depositCode: yearsToMat}));
        }
        debugLog("useUpdateDepositCodeBasedOnMatAndEffectiveDates 1");
    }, [plan.planTypeID, plan.maturityDate, plan.effectiveDate]);

    const plan2 = state.plan2;
    const setPlan2 = state.setPlan2;

    useEffect(() => {
        if (!state.enrollment.state) { return; }
        const yearsToMat = yearsToMaturity(state);
        if (yearsToMat <= 0) { return; }
        if (plan2.planTypeID === PLAN_TYPE_IDS.GROUP) {
            let depositCode = 18 - yearsToMat + 1;
            if (depositCode < 1) {
                depositCode = 1; //This should never happen
            }
            if (depositCode > 13) {
                depositCode = 13;
            }
            setPlan2(prevData => ({...prevData, depositCode: depositCode}));
        } else {
            setPlan2(prevData => ({...prevData, depositCode: yearsToMat}));
        }
        debugLog("useUpdateDepositCodeBasedOnMatAndEffectiveDates 1");
    }, [plan2.planTypeID, plan2.maturityDate, plan2.effectiveDate]);



    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (plan.planTypeID !== PLAN_TYPE_IDS.GROUP) {
            //depositCode can only be manually set for non-group plans
            //If the deposit code is greater than the years to maturity, we need to reset it
            if (plan.depositCode > yearsToMaturity(state) && yearsToMaturity(state) > 0) {
                setPlan(prevData => ({...prevData, depositCode: yearsToMaturity(state)}));
            }
        }
        debugLog("useUpdateDepositCodeBasedOnMatAndEffectiveDates 2");
    }, [plan.depositCode]);
}